import type { ComponentProps, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { CheckIcon } from '~components/icons/CheckIcon';
import { Button } from '~modules/media-library/view/Button';

export const FilterSelectToggleButton = forwardRef<
  ComponentRef<typeof Button>,
  Omit<ComponentProps<typeof Button>, 'variant'> & { selected?: boolean }
>(function FilterSelectToggleButton({ children, selected = false, ...ButtonProps }, ref) {
  return (
    <Button {...ButtonProps} ref={ref}>
      {selected && <CheckIcon className="w-4 h-4 rounded-full bg-black text-white -ml-1 mr-1" />} {children}
    </Button>
  );
});
